export const isLocaleSameDay = (a: Date, b: Date, timeZone: string) => {
  return (
    a.toLocaleString("fr-FR", { year: "numeric", month: "numeric", day: "numeric", timeZone }) ===
    b.toLocaleString("fr-FR", { year: "numeric", month: "numeric", day: "numeric", timeZone })
  );
};
